import { yupResolver } from '@hookform/resolvers/yup';
import Stack from '@mui/material/Stack';
import React from 'react';
import { useForm, FieldValues, FormProvider } from 'react-hook-form';
import { object, string } from 'yup';

import LoginFormDefaultValues from '../../formDefaultValues/LoginFormDefaultValues';
import ILoginParams from '../../types/ILoginParams';
import { ControlledTextInput } from '../ControlledTextInput';
import { Item } from '../Item';
import { WsButton } from '../WsButton';

const validationSchema = object().shape({
  username: string().required('Email is required').email('Email is invalid'),
  password: string()
    .min(4, 'Password must be at least 4 characters')
    .required('Password is required'),
});

interface ILoginForm {
  forgotPassword: React.ReactNode;
  onSubmit(args: ILoginParams): void;
  errorElement?: React.ReactElement;
  amplitudeHandler?: () => any;
}

const LoginForm: React.FC<ILoginForm> = ({
  forgotPassword,
  onSubmit,
  errorElement,
  amplitudeHandler,
}) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: LoginFormDefaultValues,
  };

  const methods = useForm(formOptions);

  const { handleSubmit } = methods;

  const onFormSubmit = (data: FieldValues) => {
    const formData: ILoginParams = {
      username: data.username,
      password: data.password,
      overrideExistingToken: false,
    };
    if (amplitudeHandler) amplitudeHandler();
    onSubmit(formData);
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <Item>
          <Stack spacing={1} direction="column">
            <ControlledTextInput
              name="username"
              labelText="Email address *"
              type="email"
              fullWidth
              id="username"
              placeholder="Eg, johndoe@email.com"
              variant="outlined"
              required
              autoComplete="email"
            />
          </Stack>
          <Stack mt={1} spacing={1} direction="column">
            <ControlledTextInput
              name={'password'}
              labelText="Enter Password *"
              type="password"
              fullWidth
              id="password"
              placeholder="Enter your password"
              variant="outlined"
              required
              autoComplete="password"
            />
          </Stack>
          <Stack direction="row" mt={1} justifyContent="flex-end">
            {forgotPassword}
          </Stack>
          <Stack mt={2}>
            {errorElement && (
              <Stack sx={{ width: '100%' }} spacing={2} mb={2}>
                {errorElement}
              </Stack>
            )}
            <WsButton variant="contained" size="large" fullWidth type="submit">
              Log In
            </WsButton>
          </Stack>
        </Item>
      </form>
    </FormProvider>
  );
};

export default LoginForm;
